import _ from 'lodash';
import validator from 'validator';

function isNumber (value) {
    if (_.isNumber(value)) {
        return true;
    }
    return !_.isEmpty(value) && validator.isNumeric(value);
}

export default isNumber;
